import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from '../reducers/auth.reducer';

export const selectAuthState = createFeatureSelector<fromAuth.State>(
  fromAuth.authFeatureKey
);

export const token = createSelector(
  selectAuthState,
  state => state.token
);

export const user_type = createSelector(
  selectAuthState,
  state => state.user_type
);

export const loading = createSelector(
  selectAuthState,
  state => state.loading
);

export const user = createSelector(
  selectAuthState,
  state => state.user
);
